import { ArrowRightOutlined } from "@ant-design/icons";
import { Alert, Button, Card, Switch, Table } from "antd";
import { Link, useNavigate } from "react-router-dom";
import AddIcon from "../../../assets/icons/AddIcon";
import BackButtonIcon from "../../../assets/icons/BackButtonIcon";
import EditIcon from "../../../assets/icons/EditIcon";
import KeyIcon from "../../../assets/icons/KeyIcon";
import UserIcon from "../../../assets/icons/UserIcon";
import BusinessInfoLogo from "../../../assets/images/business-info-logo.svg";
import digiGoLogo from "../../../assets/images/digiGo-logo.png";
import ConfirmActionModal from "../../../components/Businesses/ConfirmActionModal";
import EditRequestsInfoModal from "../../../components/Businesses/EditRequestsInfoModal";
import TopCard from "../../../components/common/TopCard";
import useModal from "../../../hooks/useModal";
import SidebarLayout from "../../../layouts/SidebarLayout";

interface LogItem {
  time: string;
  date: string;
  message: string;
  user: string;
  role: string;
  status: "success" | "warning" | "error";
}

const logs: LogItem[] = [
  {
    time: "06:01 PM",
    date: "06 Nov, 2024",
    message: "This Business Activated Successfully!",
    user: "Md Abdul Hamid",
    role: "System Admin",
    status: "success",
  },
  {
    time: "06:01 PM",
    date: "06 Nov, 2024",
    message: "Request to Active This Business",
    user: "Md Abdul Hamid",
    role: "Finance Admin",
    status: "warning",
  },
  {
    time: "06:01 PM",
    date: "06 Nov, 2024",
    message: "This Business Inactivated Successfully!",
    user: "Md Abdul Hamid",
    role: "System Admin",
    status: "error",
  },
  {
    time: "06:01 PM",
    date: "06 Nov, 2024",
    message: "Request to Inactive This Business",
    user: "Md Abdul Hamid",
    role: "Business Team",
    status: "warning",
  },
];

const statusColors = {
  success: "bg-green-500",
  warning: "bg-yellow-400",
  error: "bg-red-500",
};

const documents = [
  {
    key: "1",
    name: "TIN Certificate",
    expireDate: "Dec 31, 2025",
    action: "N/A",
  },
  {
    key: "2",
    name: "Trade License",
    expireDate: "Dec 31, 2025",
    action: "N/A",
  },
];

const columns = [
  { title: "Name", dataIndex: "name", key: "name" },
  { title: "Expire Date", dataIndex: "expireDate", key: "expireDate" },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
    render: (text: string) => (
      <a href="/" className="text-blue-500">
        {text}
      </a>
    ),
  },
];

export default function RequestsListDetails() {
  const navigate = useNavigate();
  const { open, handleOpen, handleClose } = useModal<undefined, "CONFIRM">();

  return (
    <SidebarLayout title="Requests Details #12345678">
      {open.type === "CONFIRM" && (
        <ConfirmActionModal
          open={open.open}
          data={open.data}
          handleClose={handleClose}
        />
      )}

      {open.type === "UPDATE" && (
        <EditRequestsInfoModal
          open={open.open}
          type={open.type}
          data={open.data}
          handleClose={handleClose}
        />
      )}

      <Alert
        message="Finance Department requested to Deactivate this Business Acount!"
        type="error"
        closable
        className="mb-5 text-[#842029] bg-[#F5C2C7]"
      />

      <TopCard
        leftChildren={
          <Button
            className="normal-dark-button"
            icon={<BackButtonIcon />}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        }
      >
        <div className="flex gap-2 items-center">
          <span className="font-semibold">Business Status</span>
          <Switch
            checked={true}
            //   onChange={(checked) => setShowHomePage(checked)}
            onClick={() => handleOpen({ type: "CONFIRM" })}
          ></Switch>
          <span>Active</span>
        </div>
      </TopCard>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-4 pb-4">
        {/* Left Section */}
        <div className="lg:col-span-2 space-y-4">
          <Card
            title="Business Info"
            extra={
              <Button
                className="!border-[#4A72FF] !text-[#4A72FF]"
                icon={<EditIcon />}
                onClick={() => handleOpen({ type: "UPDATE" })}
              >
                Edit Info
              </Button>
            }
          >
            <div>
              <img src={BusinessInfoLogo} alt="Business Info Logo" />
            </div>
            <div className="space-y-2 mt-4 text-sm font-medium">
              <div className="flex justify-between items-center border-b border-[#AFBACA] pb-2">
                <strong className="text-[#8897AE]">Company Name:</strong>
                <div className="text-display-body">Elevate Digital Agency</div>
              </div>
              <div className="flex justify-between items-center border-b border-[#AFBACA] pb-2">
                <strong className="text-[#8897AE]">Email:</strong>
                <div className="text-display-body">
                  bakerhossain.cse@gmail.com
                </div>
              </div>
              <div className="flex justify-between items-center border-b border-[#AFBACA] pb-2">
                <strong className="text-[#8897AE]">Mobile No:</strong>
                <div className="text-display-body">+8801730453206</div>
              </div>
              <div className="flex justify-between items-center border-b border-[#AFBACA] pb-2">
                <strong className="text-[#8897AE]">Joining Date:</strong>
                <div className="text-display-body">
                  Nov 08, 2021 | 2 Months Ago
                </div>
              </div>
              <div className="flex justify-between items-center">
                <strong className="text-[#8897AE]">Location:</strong>
                <div className="text-display-body">
                  House 11, Road 21, Block C, Section 10, Dhaka-1216
                </div>
              </div>
            </div>

            <div className="bg-white mt-8">
              <div className="bg-[#F0F3F9] p-4 text-lg font-semibold mb-4 rounded-[6px] h-[42px] text-display-body text-base flex items-center justify-start gap-2 flex-shrink-0">
                Documents
              </div>
              <div className="mb-4">
                <Table
                  dataSource={documents}
                  columns={columns}
                  pagination={false}
                />
              </div>

              <div className="bg-[#F0F3F9] p-4 text-lg font-semibold mb-4 rounded-[6px] h-[42px] text-display-body text-base flex items-center justify-start gap-2 flex-shrink-0">
                Bank Information
              </div>

              <div className="space-y-2 my-4 text-sm font-medium mb-4">
                <div className="flex justify-between items-center border-b border-[#AFBACA] pb-2">
                  <strong className="text-[#8897AE]">Bank Name:</strong>
                  <div className="text-display-body">Dhaka Bank PLC</div>
                </div>

                <div className="flex justify-between items-center border-b border-[#AFBACA] pb-2">
                  <strong className="text-[#8897AE]">Account Number:</strong>
                  <div className="text-display-body">182362XXXXX</div>
                </div>

                <div className="flex justify-between items-center">
                  <strong className="text-[#8897AE]">Branch:</strong>
                  <div className="text-display-body">Motijheel</div>
                </div>
              </div>

              <div className="bg-[#F0F3F9] p-4 text-lg font-semibold mb-4 rounded-[6px] h-[42px] text-display-body text-base flex items-center justify-start gap-2 flex-shrink-0">
                Password Change
              </div>
              <div className="flex justify-between items-center mt-4">
                <div className="text-[#8897AE] text-sm">Password Reset</div>
                <Button
                  danger
                  className="flex gap-1 items-center"
                  onClick={() => {
                    handleOpen({ type: "CONFIRM" });
                  }}
                >
                  <KeyIcon /> <span>Password Reset</span>
                </Button>
              </div>
            </div>
          </Card>
        </div>
        {/* Right Section */}
        <div className="space-y-4">
          <div
            className="flex justify-between items-center w-80 h-[42px] bg-[#F0F3F9] shadow-sm rounded-lg pl-6 pr-4"
            style={{ border: "1px solid #E9EFF6" }}
          >
            <h5 className="text-lg font-semibold flex-shrink-0">Products</h5>

            <Button
              className="text-base !bg-transparent !border-none !shadow-none !text-[#FE7235] hover:!text-[#FE7235] hover:!bg-transparent focus:!outline-none focus:!ring-0 flex items-center justify-center gap-2 flex-shrink-0"
              type="default"
              icon={<AddIcon />}
            >
              Add
            </Button>
          </div>

          <Card className="w-80 shadow-sm border border-gray-200 rounded-lg p-0">
            {/* Header Section */}
            <div className="flex justify-between items-center mb-4">
              <div className="flex items-center space-x-2">
                <img src={digiGoLogo} alt="DigiGO" className="w-[100px]" />
              </div>

              <span className="status-success">Active</span>
            </div>

            {/* Content Section */}
            <div className="flex justify-between text-gray-500 text-sm text-[#8897AE]">
              <span>Package</span>
              <span>Package Expire</span>
            </div>

            <div className="flex justify-between items-center mt-1">
              <a href="/" className="text-blue-600 font-medium text-base">
                Package Name
              </a>
              <span className="text-[#1A1F36] font-medium text-base">
                20 Jan, 2026
              </span>
            </div>

            {/* Footer Section */}
            <div className="mt-4 flex justify-end">
              <Link
                to="/admin/businesses/requests-list/package-details"
                className="text-orange-500 flex items-center text-sm"
              >
                Details <ArrowRightOutlined className="ml-1" />
              </Link>
            </div>
          </Card>
          <Card className="w-80 shadow-sm border border-gray-200 rounded-lg p-0">
            {/* Header Section */}
            <div className="flex justify-between items-center mb-4">
              <div className="flex items-center space-x-2">
                <img src={digiGoLogo} alt="DigiGO" className="w-[100px]" />
              </div>

              <span className="status-success">Active</span>
            </div>

            {/* Content Section */}
            <div className="flex justify-between text-gray-500 text-sm text-[#8897AE]">
              <span>Package</span>
              <span>Package Expire</span>
            </div>

            <div className="flex justify-between items-center mt-1">
              <a href="/" className="text-blue-600 font-medium text-base">
                Package Name
              </a>
              <span className="text-[#1A1F36] font-medium text-base">
                20 Jan, 2026
              </span>
            </div>

            {/* Footer Section */}
            <div className="mt-4 flex justify-end">
              <a href="/" className="text-orange-500 flex items-center text-sm">
                Details <ArrowRightOutlined className="ml-1" />
              </a>
            </div>
          </Card>

          <div
            className="flex justify-between items-center w-80 h-[42px] bg-[#F0F3F9] shadow-sm rounded-lg pl-6 pr-4 mt-8"
            style={{ border: "1px solid #E9EFF6" }}
          >
            <h5 className="text-lg font-semibold flex-shrink-0">Logs</h5>
          </div>

          <Card className="w-80">
            <div className="mt-1 space-y-4">
              {logs.map((log, index) => (
                <div key={index} className="relative pl-6">
                  {/* Timeline Connector */}
                  {index !== logs.length - 1 && (
                    <div className="absolute left-2 top-5 w-0.5 h-full border-l-2 border-[#AFBACA] border-dashed"></div>
                  )}
                  {/* Timeline Indicator */}
                  <div
                    className={`absolute left-0 w-4 h-4 rounded-full ${
                      statusColors[log.status]
                    }`}
                  ></div>

                  {/* Log Content */}
                  <div className="text-[12px] ml-3">
                    <div className="font-semibold text-gray-600 text-[#C19C60]">
                      {log.time} - {log.date}
                    </div>
                    <p className="text-gray-700 text-display-body text-sm mb-1">
                      {log.message}
                    </p>
                    <div className="text-blue-500  flex items-center">
                      <div className="flex items-center gap-2">
                        <span className="text-[#FE7235] w-4 h-4 inline-flex items-center justify-center">
                          <UserIcon />
                        </span>
                        <span className="text-nowrap italic text-[#8897AE]">
                          {log.user} -{" "}
                        </span>
                      </div>
                      <span className="font-medium text-gray-600 ml-1 text-nowrap italic text-[#8897AE]">
                        {log.role}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Card>
        </div>
      </div>
    </SidebarLayout>
  );
}
